import { escapeRegExp } from 'lodash'
import moment from 'moment'
import 'moment/locale/th'
import * as CryptoJS from 'crypto-js'
import {
  BannerPosition,
  BannerStatus,
  BannerStatusText,
  BannerPositionText,
  StatusText,
  CouponMinimumType,
  CouponMinimumTypeText,
  MerchantStatusText,
  CreatedByText,
  ManufacurerStatus,
  ManufacurerStatusText,
  CategoriesStatus,
  CategoriesStatusText,
  ProductStatus,
  ProductStatusText,
  ProductRequestStatus,
  ProductRequestStatusText,
  OrderStatus,
  OrderStatusShortText,
  PaymentType,
  PaymentTypeText,
  DeliveryType,
  DeliveryTypeText,
  UserStatusText,
  StaffStatus,
  AdsStatus,
  CampaignWithProduct,
  PurchaseStatus,
  PurchaseStatusText,
  DefaultStatus,
  PaymentTypes,
  menuSupplierPaymentTypes,
  menuBankAccount,
  GrnStatus,
  GrnStatusText,
  QuotationStatus,
  QuotationStatusText,
  DiscountType,
  DiscountText,
  SupplierOrderStatus,
  SupplierOrderStatusText,
  TaxInvoiceType,
  TaxInvoiceTypeText,
  SupplierInvoiceStatus,
  SupplierInvoiceStatusText,
  StockMovementType,
  StockMovementTypeText,
  StockMovementChannel,
  StockMovementChannelText,
  monthNames,
  PaymentTypesText,
  ReturnStatus,
  ReturnStatusText,
  EarnPointType,
  EarnPointTypeTitle,
} from './constanst'
import PromptpayIcon from '../assets/img/pay.png'
import CodIcon from '../assets/img/cod.png'
import CreditIcon from '../assets/img/credit.png'
import CashIcon from '../assets/img/cash.png'
import CashdrawerIcon from '../assets/img/cashdrawer.png'
import ChequeIcon from '../assets/img/cheque.png'
import TransferIcon from '../assets/img/money-transfer.png'
import { AddressData } from 'Store/common/common.types'
import { ConfigData } from 'Store/pos/types'
import { MultiUom } from 'Store/product/types'

export const calendarFormat = 'll'

export const toDateQuery = (date: any, format = 'YYYY-MM-DD') =>
  moment.isMoment(date) ? date.format(format) : date || ''

export const toDateMoment = (val: any, withTime: boolean = false): any => {
  moment.locale('th')
  if (typeof val === 'string') {
    if (withTime) {
      return val === '' ? undefined : moment(val, 'YYYY-MM-DD HH:mm')
    } else {
      return val === '' ? undefined : moment(val, 'YYYY-MM-DD')
    }
  }

  return val
}

export const toMoment = (val: any): any => {
  if (val === '') return undefined

  return moment(val)
}

export const formatDateTime = (date: string): any => {
  if (!date) return ''
  moment.locale('th')
  return moment(date)
    .add(543, 'year')
    .format('lll')
}

export const formatDateWithoutTime = (date: string): any => {
  if (!date) return ''
  moment.locale('th')
  return moment(date)
    .add(543, 'year')
    .format('ll')
}

export const formatTimeWithoutDate = (date: string): any => {
  if (!date) return ''
  moment.locale('th')
  return moment(date).format('HH:mm')
}

export const formatDate = (date: string): any => {
  if (!date) return ''
  moment.locale('th')
  return moment(date).format('DD/MM/YYYY')
}

export const formatDateCustom = (date: string, format: string): any => {
  if (!date) return ''
  moment.locale('th')
  return moment(date).format(format)
}

export const formatDateUTC = (date: string): any => {
  const dateTimeInUtc = moment(date).toISOString()
  return dateTimeInUtc
}

export const formatTimeAgo = (date: string): any => {
  moment.locale('th')
  const fromDate = moment(date)
  return fromDate.fromNow(false)
}

export const currentDateTime = (): any => {
  moment.locale('th')
  return moment().format('DD-MM-YYYY HH:mm')
}

export const currentDateTimeUTC = (): any => {
  const dateTimeInUtc = moment().toISOString()
  return dateTimeInUtc
}

export const currentDateTimeThaiformat = (): any => {
  moment.locale('th')
  return moment()
    .add(543, 'year')
    .format('ll')
}

export const currentDate = (): any => {
  moment.locale('th')
  return moment().format('YYYY-MM-DD')
}

export const currentDateImport = (): any => {
  moment.locale('th')
  return moment().format('YYYYMMDD')
}

export const getLast1Month = (): any => {
  const last = moment()
    .endOf('day')
    .subtract(1, 'months')
  return last
}

export const getLast1Week = (): any => {
  const last = moment()
    .endOf('day')
    .subtract(1, 'weeks')
  return last
}

export const getMonday = () => {
  const now = moment()
  return now.clone().weekday(1)
}

export const getSunday = () => {
  const now = moment()
  now.clone().weekday(7)
  return now.clone().weekday(7)
}

export const getFirstdayOfMonth = () => {
  return moment().startOf('month')
}

export const getLastdayOfMonth = () => {
  return moment().endOf('month')
}

export const getDateFromNow = (day: number): any => {
  const date = moment()
    .endOf('day')
    .add(day, 'day')
  return date
}

export const getDiffDay = (endDate: string): any => {
  const now = moment.now()
  const end = moment(endDate)
  const day = moment.duration(end.diff(now)).asDays()
  return day
}

export const getNewEndDate = (endDate: string, addDay: number): any => {
  const end = moment(endDate).add(addDay, 'days')
  return end.add(543, 'year').format('lll')
}

export const isAfter = (date: string): any => {
  const now = moment()
  return now.isAfter(moment(date))
}

export const isBefore = (date: string): any => {
  const now = moment()
  return now.isBefore(moment(date))
}

export const renderTime = () => {
  const values = []

  for (let index = 0; index < 24; index++) {
    const name = index <= 9 ? '0' + index : index
    values.push(`${name}:00`)
  }

  return values
}

export const formatBirthdate = (date: string): any => {
  if (!date) return ''
  moment.locale('th')
  return moment(date)
    .add(543, 'year')
    .format('ll')
}

export const formatCreditCard = (no: string): any => {
  //:TODO
  return no
}

export const formatAddress = (
  address: string = '',
  district: string = '',
  amphor: string = '',
  province: string = '',
  postcode: string = '',
): string => {
  if (!address.trim() && !district.trim() && !amphor.trim() && !province.trim() && !postcode.trim()) return ''
  const amphorTitle = amphor.search('เขต') === 0 ? '' : 'เขต/อำเภอ'
  const districtTitle = 'แขวง/ตำบล'
  return `${address || '-'} ${districtTitle} ${district || '-'} ${amphorTitle} ${amphor ||
    '-'} จังหวัด ${province || '-'} รหัสไปรษณีย์ ${postcode || '-'}`
}

export const formatAddressNoTitle = (
  address: string,
  district: string,
  amphor: string,
  province: string,
  postcode: string,
): string => {
  if (!address.trim() && !district.trim() && !amphor.trim() && !province.trim() && !postcode.trim()) return ''
  return ` ${address || '-'} ${district || '-'} ${amphor || '-'} ${province || '-'} ${postcode || '-'}`
}

export const formatSex = (sex: string): any => {
  if (!sex) return ''
  return sex === 'male' ? 'ชาย' : 'หญิง'
}

export const formatBusinessType = (type: string): any => {
  if (!type) return ''
  return type === 'individual' ? 'บุคคลธรรมดา' : 'นิติบุคคล'
}

export const numberWithComma = (
  number: number = 0,
  isNumFormat: boolean = false,
  digit: number = 2,
): string => {
  if (isNumFormat) {
    return number.toFixed(digit).replace(/\d(?=(\d{3})+\.)/g, '$&,')
  }
  return number.toLocaleString()
}

export const numberWithThbCurrency = (
  number: number = 0,
  isNumFormat: boolean = false,
  digit: number = 2,
): string => {
  if (isNumFormat) {
    return '฿' + number.toFixed(digit).replace(/\d(?=(\d{3})+\.)/g, '$&,')
  }
  return '฿' + number.toLocaleString()
}

export const mergeArray = (datas: any[]) => {
  let result = [] as any[]
  if (datas) {
    datas.forEach(item => {
      result = result.concat(item)
    })
  }

  return result
}

export const roundNumber = (number: number = 0): number => {
  return Math.round((number + Number.EPSILON) * 100) / 100
}

export const parseNumberToInt = (number: number = 0): number => {
  return Math.trunc(number + Number.EPSILON)
}

export const formatStatusPayment = (status: string): string => {
  switch (status.toLowerCase()) {
    case 'pending':
      return 'รอการชำระเงิน'
    case 'success':
      return 'ชำระเงินสำเร็จ'
    default:
      return status
  }
}

export const formatPaymentChannel = (type: string): string => {
  switch (type) {
    case PaymentType.CREDIT:
      return PaymentTypeText.CREDIT
    case PaymentType.COD:
      return PaymentTypeText.COD
    case PaymentType.CASH:
      return PaymentTypeText.CASH
    case PaymentType.PP:
      return PaymentTypeText.PP
    case PaymentType.POS:
      return PaymentTypeText.POS
    case PaymentType.TRANSFER_POS:
      return PaymentTypeText.TRANSFER_POS
    case PaymentType.TRANSFER_QR:
      return PaymentTypeText.TRANSFER_QR
    case PaymentType.TRANSFER_CREDIT_TERM:
      return PaymentTypeText.TRANSFER_CREDIT_TERM
    default:
      return type
  }
}

export const validateEmail = (mail: string) => {
  if (/^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$/.test(mail)) {
    return true
  }
  return false
}

export const formatUnitWaranty = (value: string): string => {
  switch (value) {
    case 'days':
      return 'วัน'
    case 'months':
      return 'เดือน'
    case 'year':
      return 'ปี'
    default:
      return value
  }
}

export const getShippingTypes = (shipping_types: string[]): string => {
  const types = [] as string[]
  shipping_types &&
    shipping_types.forEach(item => {
      types.push(formatShippingTypes(item))
    })
  return types.join(',')
}

export const formatShippingTypes = (value: string): string => {
  switch (value) {
    case DeliveryType.PUBLIC:
      return DeliveryTypeText.PUBLIC
    case DeliveryType.SHOP:
      return DeliveryTypeText.SHOP
    case DeliveryType.FREE:
      return DeliveryTypeText.FREE
    case DeliveryType.PICKUP:
      return DeliveryTypeText.PICKUP
    default:
      return value
  }
}

export const mapWordingReport = (data: string) => {
  let result = replaceAll(data, DeliveryType.PUBLIC, formatShippingTypes(DeliveryType.PUBLIC))
  result = replaceAll(result, DeliveryType.SHOP, formatShippingTypes(DeliveryType.SHOP))
  result = replaceAll(result, DeliveryType.FREE, formatShippingTypes(DeliveryType.FREE))
  result = replaceAll(result, DeliveryType.PICKUP, formatShippingTypes(DeliveryType.PICKUP))
  result = replaceAll(result, OrderStatus.PENDING, getOrderStatus(OrderStatus.PENDING).text)
  result = replaceAll(result, OrderStatus.SUCCESS, getOrderStatus(OrderStatus.SUCCESS).text)
  result = replaceAll(result, OrderStatus.CONFIRMED, getOrderStatus(OrderStatus.CONFIRMED).text)
  result = replaceAll(result, OrderStatus.ON_DELIVERY, getOrderStatus(OrderStatus.ON_DELIVERY).text)
  result = replaceAll(result, OrderStatus.DELIVERED, getOrderStatus(OrderStatus.DELIVERED).text)
  result = replaceAll(
    result,
    OrderStatus.CONFIRM_RECEICVED,
    getOrderStatus(OrderStatus.CONFIRM_RECEICVED).text,
  )
  result = replaceAll(result, OrderStatus.CANCEL, getOrderStatus(OrderStatus.CANCEL).text)
  result = replaceAll(result, PaymentType.CREDIT, formatPaymentChannel(PaymentType.CREDIT))
  result = replaceAll(result, PaymentType.COD, formatPaymentChannel(PaymentType.COD))
  result = replaceAll(result, PaymentType.CASH, formatPaymentChannel(PaymentType.CASH))
  result = replaceAll(result, PaymentType.PP, formatPaymentChannel(PaymentType.PP))
  result = replaceAll(result, PaymentType.POS, formatPaymentChannel(PaymentType.POS))
  result = replaceAll(result, PaymentType.TRANSFER_POS, formatPaymentChannel(PaymentType.TRANSFER_POS))
  return result
}

export const replaceAll = (str: string, find: string, replace: any): string => {
  return str.replace(new RegExp(escapeRegExp(',' + find + ','), 'g'), ',' + replace + ',')
}

export const replaceStr = (str: string, find: string, replace: any): string => {
  return str.replace(new RegExp(escapeRegExp(find), 'g'), replace)
}

export const getRequestString = (params: any) => {
  let string = ''
  for (const key in params) {
    string += string !== '' ? '&' : string
    string += `${key}=${params[key] ? params[key] : ''}`
  }
  return string
}

export const getBannerStatus = (status: BannerStatus) => {
  const isPublic = status === BannerStatus.PUBLISH
  return isPublic ? BannerStatusText.PUBLISH : BannerStatusText.UNPUBLISH
}

export const bannerPositionText = (position: BannerPosition): string => {
  switch (position) {
    case BannerPosition.PRODUCT:
      return BannerPositionText.PRODUCT
    case BannerPosition.SLIDER:
      return BannerPositionText.SLIDER
    default:
      return ''
  }
}

export const getCouponStatus = (isPublic: boolean) => {
  return isPublic ? StatusText.PUBLISH : StatusText.UNPUBLISH
}

export const getMerchantsStatus = (verified: boolean, rejected: boolean) => {
  let text = MerchantStatusText.WAITING
  if (verified && !rejected) {
    text = MerchantStatusText.APPROVE
  }
  if (rejected) {
    text = MerchantStatusText.REJECT
  }
  return text
}

export const getStatus = (val: boolean) => {
  return val ? StatusText.PUBLISH : StatusText.UNPUBLISH
}

export const getCouponMinimumType = (type: CouponMinimumType) => {
  return type === CouponMinimumType.MINIMUM ? CouponMinimumTypeText.MINIMUM : CouponMinimumTypeText.UNLIMIT
}

export const getCouponProductType = (type: CampaignWithProduct) => {
  return type === CampaignWithProduct.ALL ? 'สินค้าทุกรายการ' : 'สินค้าบางรายการ'
}

export const getDiscountType = (type: string) => {
  return type === DiscountType.AMOUNT ? DiscountText.AMOUNT : DiscountText.PERCENT
}

export const isFormRequired = (requireFeild: string[], name: string) => {
  if (requireFeild.includes(name)) return true
  return false
}

export const isFormError = (formError: string[], name: string) => {
  if (formError.includes(name)) return true
  return false
}

export const isFilter = (filter: any) => {
  for (const prop in filter) {
    if (filter && filter[prop]) return true
  }
  return false
}

export const isFormDisabled = (requireFeild: string[], name: string) => {
  if (requireFeild.includes(name)) return true
  return false
}
export const formValidation = (requireFeild: string[], formData: any) => {
  const error = [] as string[]
  requireFeild.forEach((name: string) => {
    if (!formData[name] || formData[name] <= 0) {
      error.push(name)
    }
  })
  return error
}

export const firstUpperCase = (text: any) => {
  if (typeof text !== 'string') return ''
  return text.charAt(0).toUpperCase() + text.slice(1)
}

export const getCreatedBySystem = (createID: number, merchantID: number) => {
  return createID === merchantID ? CreatedByText.MERCHANT : CreatedByText.SYSTEM
}

export const getManufacturersStatus = (status: ManufacurerStatus) => {
  let text = ''
  switch (status) {
    case ManufacurerStatus.DRAFT:
      text = ManufacurerStatusText.DRAFT
      break
    case ManufacurerStatus.PUBLISH:
      text = ManufacurerStatusText.PUBLISH
      break
    case ManufacurerStatus.UNPUBLISH:
      text = ManufacurerStatusText.UNPUBLISH
      break
    default:
      text = ManufacurerStatusText.DRAFT
      break
  }
  return text
}

export const getCategoriesStatus = (status: CategoriesStatus) => {
  return status === CategoriesStatus.ACTIVE ? CategoriesStatusText.ACTIVE : CategoriesStatusText.INACTIVE
}

export const getProductStatus = (status: string) => {
  return status === ProductStatus.ACTIVE ? ProductStatusText.ACTIVE : ProductStatusText.INACTIVE
}

export const getProductRequestStatus = (status: string) => {
  let text = ''
  let color = ''

  switch (status) {
    case ProductRequestStatus.PENDING:
      text = ProductRequestStatusText.PENDING
      color = 'orange'
      break
    case ProductRequestStatus.APPROVED:
      text = ProductRequestStatusText.APPROVED
      color = 'green'
      break
    case ProductRequestStatus.REJECTED:
      text = ProductRequestStatusText.REJECTED
      color = 'red'
      break
    case ProductRequestStatus.CANCELLED:
      text = ProductRequestStatusText.CANCELLED
      color = 'red'
      break

    default:
      text = status
      color = 'white'
      break
  }
  return { status, text, color }
}

export const getProductRequestAction = (action: string) => {
  let text = ''
  let color = ''

  switch (action) {
    case 'create':
      text = 'เพิ่มสินค้า'
      color = 'grey'
      break
    case 'update':
      text = 'แก้ไขสินค้า'
      color = 'grey'
      break
    case 'rejected':
      text = 'ไม่อนุมัติ'
      color = 'red'
      break
    case 'approved':
      text = 'ทำรายการสำเร็จ'
      color = 'green'
      break
    case 'update-price':
      text = 'ปรับราคาสินค้า'
      color = 'grey'
      break

    default:
      text = action
      color = 'white'
      break
  }
  return { action, text, color }
}

export const getMenuSelect = (data: any[], nameKey: string = 'name', valueKey: string = 'id'): any[] => {
  const menu = [] as any[]
  data &&
    data.forEach((item: any) => {
      menu.push({
        name: item[nameKey] || '',
        value: item[valueKey] || '',
      })
    })
  return menu
}

export const getSupplierMenuSelect = (
  data: any[],
  nameKey: string = 'name',
  valueKey: string = 'id',
): any[] => {
  const menu = [] as any[]
  data &&
    data.forEach((item: any) => {
      menu.push({
        name: `${item[nameKey]} (${item['supplier_code']})`,
        value: item[valueKey] || '',
      })
    })
  return menu
}

export const getCustomerMenuSelect = (
  data: any[],
  nameKey: string = 'name',
  valueKey: string = 'id',
  ignoreFranchise: boolean = false,
): any[] => {
  const menu = [] as any[]
  data &&
    data.forEach((item: any) => {
      if (ignoreFranchise) {
        if (item?.customer_type !== 'franchise') {
          menu.push({
            name: `${item['mobile']} : ${item[nameKey]}`,
            value: item[valueKey] || '',
          })
        }
      } else {
        menu.push({
          name: `${item['mobile']} : ${item[nameKey]}`,
          value: item[valueKey] || '',
        })
      }
    })
  return menu
}

export const getCustomerTaxMenuSelect = (
  data: any[],
  nameKey: string = 'name',
  valueKey: string = 'id',
): any[] => {
  const menu = [] as any[]
  data &&
    data.forEach((item: any) => {
      menu.push({
        name: `${item[nameKey]} (${item['taxpayer_no']})`,
        value: item[valueKey] || '',
      })
    })
  return menu
}

export const getPriceConfigsMenuSelect = (
  data: any[],
  nameKey: string = 'value',
  valueKey: string = 'name',
): any[] => {
  const menu = [] as any[]
  data &&
    data.forEach((item: any) => {
      menu.push({
        name: `${item[nameKey]} ${item['description'] ? '(' + item['description'] + ')' : ''}`,
        value: item[valueKey] || '',
      })
    })
  return menu
}

export const getUomsMenuSelect = (data: MultiUom[], isActive: boolean = true): any[] => {
  const masterUom = data?.find(item => item.is_master)
  const menu = [] as any[]
  const filterUom = filterUoms(data, isActive)
  filterUom &&
    filterUom.forEach((item: MultiUom) => {
      menu.push({
        name: `${item.uom_name} ${item.is_master ? '' : `(${item.multiplier} ${masterUom?.uom_name})`}`,
        value: item.id,
      })
    })
  return menu
}

export const filterUoms = (data: MultiUom[], isActive: boolean = false): MultiUom[] => {
  if (isActive) {
    return data?.filter(item => item.status === DefaultStatus.ACTIVE)
  }
  return data
}

export const getDeliveryMenuSelect = (
  data: any[],
  nameKey: string = 'name',
  valueKey: string = 'id',
): any[] => {
  const menu = [] as any[]
  data.forEach((item: any) => {
    menu.push({
      name: item?.is_default && item?.is_default ? 'ระยะการส่งมาตรฐาน 50 กม.' : item[nameKey] || '',
      value: item[valueKey] || '',
    })
  })
  return menu
}

export const getCategoriesName = (data: any): string => {
  return `${data?.group?.name || ''} / ${data?.category?.name || ''} / ${data?.sub_category?.name || ''}`
}

export const getDeliveryCostMenu = (menu: any[], type: string): any[] => {
  return menu.map((item: any) => {
    const name = item.name || ''
    return {
      name: name.replace('{type}', type),
      value: item.value,
    }
  })
}

export const getUomReturnMenu = (
  product_uom_id: number,
  product_uom: string,
  product_uom_system_id: number,
  product_uom_system: string,
) => {
  const menu = [] as {
    name: any
    value: any
  }[]
  menu.push({
    name: `${product_uom}`,
    value: product_uom_id,
  })
  menu.push({
    name: `${product_uom_system}`,
    value: product_uom_system_id,
  })
  return menu
}

export const getQtyMenu = (qty: number, uom: string) => {
  const qtyMenu = [] as {
    name: any
    value: any
  }[]
  for (let index = 1; index <= qty; index++) {
    qtyMenu.push({
      name: `${index} ${uom}`,
      value: index,
    })
  }
  return qtyMenu
}

export const getOrderStatus = (status: string) => {
  let text = ''
  let color = ''
  switch (status) {
    case OrderStatus.PENDING:
      text = OrderStatusShortText.PENDING
      color = 'gold'
      break
    case OrderStatus.SUCCESS:
      text = OrderStatusShortText.SUCCESS
      color = 'blue'
      break
    case OrderStatus.CONFIRMED:
      text = OrderStatusShortText.CONFIRMED
      color = 'geekblue'
      break
    case OrderStatus.ON_DELIVERY:
      text = OrderStatusShortText.ON_DELIVERY
      color = 'lime'
      break
    case OrderStatus.DELIVERED:
      text = OrderStatusShortText.DELIVERED
      color = 'green'
      break
    case OrderStatus.CONFIRM_RECEICVED:
      text = OrderStatusShortText.CONFIRM_RECEICVED
      color = 'green'
      break
    case OrderStatus.CANCEL:
      text = OrderStatusShortText.CANCEL
      color = 'red'
      break
    default:
      text = status
      break
  }
  return {
    text,
    color,
  }
}

export const getIncomeChart = (type: string) => {
  let text = ''
  let color = ''
  let icon = ''
  switch (type) {
    case PaymentType.COD:
      text = 'เก็บเงินปลายทาง (COD)'
      color = '#D35025'
      icon = CodIcon
      break
    case PaymentType.PP:
      text = 'พร้อมเพย์ (โอนเงิน)'
      color = '#FFBF00'
      icon = PromptpayIcon
      break
    case PaymentType.CASH:
      text = 'ชำระเงินหน้าร้าน (เงินสด)'
      color = '#F4AF55'
      icon = CashIcon
      break
    case PaymentType.CREDIT:
      text = 'บัตรเครดิต'
      color = '#DF742D'
      icon = CreditIcon
      break
    case PaymentType.POS:
      text = 'เงินสด (Terminal)'
      color = '#135200'
      icon = CashdrawerIcon
      break
    case PaymentType.TRANSFER_POS:
      text = 'เงินโอน (Terminal)'
      color = 'rgb(24 144 255 / 90%)'
      icon = TransferIcon
      break
    case PaymentType.TRANSFER_QR:
      text = PaymentTypeText.TRANSFER_QR
      color = 'rgb(24 144 255 / 60%)'
      icon = PromptpayIcon
      break
    case PaymentType.TRANSFER_CREDIT_TERM:
      text = PaymentTypeText.TRANSFER_CREDIT_TERM
      color = 'rgb(24 144 255 / 30%)'
      icon = TransferIcon
      break
    default:
      text = status
      break
  }
  return {
    text,
    color,
    icon,
  }
}

export const getSupplierIncomeChart = (type: any) => {
  let text = ''
  let color = ''
  let icon = ''
  switch (type) {
    case PaymentTypes.CASH:
      text = PaymentTypesText.CASH
      color = '#AC512A'
      icon = CashIcon
      break
    case PaymentTypes.CHECK:
      text = PaymentTypesText.CHECK
      color = '#99AE83'
      icon = ChequeIcon
      break
    case PaymentTypes.CREDIT:
      text = PaymentTypesText.CREDIT
      color = '#D9C999'
      icon = CreditIcon
      break
    case PaymentTypes.TRANSFER:
      text = PaymentTypesText.TRANSFER
      color = '#EB8C55'
      icon = PromptpayIcon
      break

    default:
      text = type
      break
  }
  return {
    text,
    color,
    icon,
  }
}

export const getUserStatus = (status: StaffStatus) => {
  const isPublic = status === StaffStatus.ACTIVE
  return isPublic ? UserStatusText.ACTIVE : UserStatusText.INACTIVE
}

export const enCryptParamMerchant = (mid: number) => {
  const ciphertext = CryptoJS.AES.encrypt(mid.toString(), 'ydnaab0851')
  return encodeURIComponent(ciphertext.toString())
}

export const getAdsStatus = (status: AdsStatus) => {
  const isPublic = status === AdsStatus.ACTIVE
  return isPublic ? 'เปิดใช้งาน' : 'ปิดใช้งาน'
}

export const validatePasswordFormat = (password: string) => {
  const validKey = []
  //const strongRegex = new RegExp('^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[!@#$%^&*])(?=.{8,})')
  const uppercase = new RegExp('^(?=.*[A-Z])')
  const lowercase = new RegExp('^(?=.*[a-z])')
  const number = new RegExp('^(?=.*[0-9])')
  const sign = new RegExp('^(?=.*[!@#$%^&*])')
  const length = new RegExp('^(?=.{8,})')
  if (uppercase.test(password)) {
    validKey.push('uppercase')
  }

  if (lowercase.test(password)) {
    validKey.push('lowercase')
  }

  if (number.test(password)) {
    validKey.push('number')
  }

  if (sign.test(password)) {
    validKey.push('sign')
  }

  if (length.test(password)) {
    validKey.push('length')
  }
  return validKey
}

export const isValidatePassword = (password: string, key: any) => {
  const validKey = validatePasswordFormat(password)
  return validKey[key] ? true : false
}

export const getPurchaseStatus = (status: string) => {
  let text = ''
  let color = ''
  switch (status) {
    case PurchaseStatus.DRAFT:
      text = PurchaseStatusText.DRAFT
      color = 'default'
      break
    case PurchaseStatus.PENDING:
      text = PurchaseStatusText.PENDING
      color = 'orange'
      break
    case PurchaseStatus.PARTIAL_RECEIPT:
      text = PurchaseStatusText.PARTIAL_RECEIPT
      color = 'blue'
      break
    case PurchaseStatus.SUCCESS:
      text = PurchaseStatusText.SUCCESS
      color = 'green'
      break
    case PurchaseStatus.CONDITION_RECEIPT:
      text = PurchaseStatusText.CONDITION_RECEIPT
      color = 'geekblue'
      break
    case PurchaseStatus.CANCEL:
      text = PurchaseStatusText.CANCEL
      color = 'red'
      break
    default:
      text = status
      break
  }
  return {
    text,
    color,
  }
}

export const getQuotationStatus = (status: string) => {
  let text = ''
  let color = ''
  switch (status) {
    case QuotationStatus.DRAFT:
      text = QuotationStatusText.DRAFT
      color = 'default'
      break
    case QuotationStatus.PENDING:
      text = QuotationStatusText.PENDING
      color = 'orange'
      break
    case QuotationStatus.SUCCESS:
      text = QuotationStatusText.SUCCESS
      color = 'green'
      break
    case QuotationStatus.CANCEL:
      text = QuotationStatusText.CANCEL
      color = 'red'
      break
    default:
      text = status
      break
  }
  return {
    text,
    color,
  }
}

export const getSupplierOrderStatus = (status: string) => {
  let text = ''
  let color = ''
  switch (status) {
    case SupplierOrderStatus.PREPARE:
      text = SupplierOrderStatusText.PREPARE
      color = 'gold'
      break
    case SupplierOrderStatus.ON_DELIVERY:
      text = SupplierOrderStatusText.ON_DELIVERY
      color = 'geekblue'
      break
    case SupplierOrderStatus.DELIVERED:
      text = SupplierOrderStatusText.DELIVERED
      color = 'green'
      break
    default:
      text = status
      break
  }
  return {
    text,
    color,
  }
}

export const getReturnOrderStatus = (status: string) => {
  let text = ''
  let color = ''
  switch (status) {
    case ReturnStatus.DRAFT:
      text = ReturnStatusText.DRAFT
      color = 'yellow'
      break
    case ReturnStatus.PENDING:
      text = ReturnStatusText.PENDING
      color = 'blue'
      break
    case ReturnStatus.SUCCESS:
      text = ReturnStatusText.SUCCESS
      color = 'green'
      break
    default:
      text = status
      break
  }
  return {
    text,
    color,
  }
}

export const getDefaultStatus = (status: DefaultStatus) => {
  const isPublic = status === DefaultStatus.ACTIVE
  return isPublic ? 'เปิดใช้งาน' : 'ปิดใช้งาน'
}

export const getSupplierPaymentType = (type?: PaymentTypes) => {
  let typeName = ''
  if (type === PaymentTypes.VOID) {
    return PaymentTypesText.VOID
  }
  menuSupplierPaymentTypes.forEach(item => {
    if (item.value === type) {
      typeName = item.name
      return
    }
  })
  return typeName
}

export const getBankName = (type?: string) => {
  let name = ''
  menuBankAccount.forEach(item => {
    if (item.value === type) {
      name = item.name
      return
    }
  })
  return name
}

export const getGrnStatus = (status: string) => {
  let text = ''
  let color = ''
  switch (status) {
    case GrnStatus.PENDING:
      text = GrnStatusText.PENDING
      color = 'red'
      break
    case GrnStatus.PATIAL:
      text = GrnStatusText.PATIAL
      color = 'blue'
      break
    case GrnStatus.SUCCESS:
      text = GrnStatusText.SUCCESS
      color = 'green'
      break

    default:
      text = status
      break
  }
  return {
    text,
    color,
  }
}

export const decimalCount = (num: number) => {
  // Convert to String
  const numStr = String(num)
  // String Contains Decimal
  if (numStr.includes('.')) {
    return numStr.split('.')[1].length
  }
  // String Does Not Contain Decimal
  return 0
}

export const getMenuTypeName = (menu: any[], val: string) => {
  let typeName = ''
  menu.forEach(item => {
    if (item?.value === val) {
      typeName = item?.name
      return
    }
  })
  return typeName
}

export const getPointStatus = (status: string) => {
  let text = ''
  let color = ''
  switch (status) {
    case 'pending':
      text = 'รอยืนยันรับสินค้า'
      color = 'orange'
      break
    case 'success':
      text = 'สะสมคะแนน'
      color = 'green'
      break
    case 'return':
      text = 'คืนคะแนน'
      color = 'blue'
      break
    default:
      text = status
      break
  }
  return {
    text,
    color,
  }
}

export const getMemberEarnPointStatus = (status: string) => {
  let text = ''
  let color = ''
  switch (status) {
    case 'pending':
      text = 'รอยืนยัน'
      color = 'orange'
      break
    case 'success':
      text = 'สำเร็จ'
      color = 'green'
      break
    case 'return':
      text = 'คืนคะแนน'
      color = 'blue'
      break
    case 'cancel':
      text = 'ยกเลิก'
      color = 'red'
      break
    default:
      text = status
      break
  }
  return {
    text,
    color,
  }
}

export const getRedeemStatus = (status: string) => {
  let text = ''
  let color = ''
  switch (status) {
    case 'reserved':
      text = 'จอง'
      color = 'orange'
      break
    case 'success':
      text = 'สำเร็จ'
      color = 'green'
      break
    case 'cancel':
      text = 'ยกเลิก'
      color = 'red'
      break

    default:
      text = status
      break
  }
  return {
    text,
    color,
  }
}

export const getTaxInvoiceType = (status: string) => {
  let text = ''
  let color = ''
  switch (status) {
    case TaxInvoiceType.SUPPLIER:
      text = TaxInvoiceTypeText.SUPPLIER
      color = 'orange'
      break
    case TaxInvoiceType.CUSTOMER:
      text = TaxInvoiceTypeText.CUSTOMER
      color = 'blue'
      break
    default:
      text = status
      break
  }
  return {
    text,
    color,
  }
}

export const getSupplierInvoiceStatus = (status: string) => {
  let text = ''
  let color = ''
  switch (status) {
    case SupplierInvoiceStatus.WAITING:
      text = SupplierInvoiceStatusText.WAITING
      color = 'gold'
      break
    case SupplierInvoiceStatus.PATIAL:
      text = SupplierInvoiceStatusText.PATIAL
      color = 'blue'
      break
    case SupplierInvoiceStatus.SUCCESS:
      text = SupplierInvoiceStatusText.SUCCESS
      color = 'green'
      break
    default:
      text = status
      break
  }
  return {
    text,
    color,
  }
}

export const getStockMovementType = (type: string) => {
  let text = ''
  let color = ''
  switch (type) {
    case StockMovementType.SALE:
      text = StockMovementTypeText.SALE
      color = 'red'
      break
    case StockMovementType.RECEIPT:
      text = StockMovementTypeText.RECEIPT
      color = 'green'
      break
    case StockMovementType.ADJUSTOUT:
      text = StockMovementTypeText.ADJUSTOUT
      color = 'gold'
      break
    case StockMovementType.VOID:
      text = StockMovementTypeText.VOID
      color = 'blue'
      break

    default:
      text = type
      break
  }
  return {
    text,
    color,
  }
}

export const getStockMovementChannel = (channel: string) => {
  let text = ''
  let color = ''
  switch (channel) {
    case StockMovementChannel.POS:
      text = StockMovementChannelText.POS
      color = 'red'
      break
    case StockMovementChannel.SUPPLIER:
      text = StockMovementChannelText.SUPPLIER
      color = 'red'
      break
    case StockMovementChannel.WEB:
      text = StockMovementChannelText.WEB
      color = 'red'
      break
    case StockMovementChannel.IOS:
      text = StockMovementChannelText.IOS
      color = 'red'
      break
    case StockMovementChannel.ANDROIND:
      text = StockMovementChannelText.ANDROIND
      color = 'red'
      break

    default:
      text = channel
      break
  }
  return {
    text,
    color,
  }
}

export const mapWordingStockMovementReport = (data: string) => {
  const dataArray = data.split('\n')
  const results = dataArray.map((result: string) => {
    if (result.includes(StockMovementType.SALE)) {
      if (result.includes(StockMovementChannel.SUPPLIER)) {
        result = replaceStr(result, SupplierOrderStatus.PREPARE, SupplierOrderStatusText.PREPARE)
        result = replaceStr(result, SupplierOrderStatus.DELIVERED, SupplierOrderStatusText.DELIVERED)
        result = replaceStr(result, SupplierOrderStatus.ON_DELIVERY, SupplierOrderStatusText.ON_DELIVERY)
      } else {
        result = replaceStr(result, OrderStatus.CONFIRMED, getOrderStatus(OrderStatus.CONFIRMED).text)
        result = replaceStr(
          result,
          OrderStatus.CONFIRM_RECEICVED,
          getOrderStatus(OrderStatus.CONFIRM_RECEICVED).text,
        )
        result = replaceStr(result, OrderStatus.ON_DELIVERY, getOrderStatus(OrderStatus.ON_DELIVERY).text)
        result = replaceStr(result, OrderStatus.DELIVERED, getOrderStatus(OrderStatus.DELIVERED).text)
      }
    }

    if (result.includes(StockMovementType.RECEIPT)) {
      result = replaceStr(result, GrnStatus.PATIAL, getGrnStatus(GrnStatus.PATIAL).text)
      result = replaceStr(result, GrnStatus.PENDING, getGrnStatus(GrnStatus.PENDING).text)
      result = replaceStr(result, GrnStatus.SUCCESS, getGrnStatus(GrnStatus.SUCCESS).text)
    }
    if (result.includes(StockMovementType.ADJUSTOUT)) {
      result = replaceStr(result, 'success', 'สำเร็จ')
    }

    if (result.includes(StockMovementType.VOID)) {
      result = replaceStr(result, ReturnStatus.PENDING, ReturnStatusText.PENDING)
      result = replaceStr(result, ReturnStatus.SUCCESS, ReturnStatusText.SUCCESS)
    }
    result = replaceStr(result, StockMovementType.SALE, getStockMovementType(StockMovementType.SALE).text)
    result = replaceStr(
      result,
      StockMovementType.RECEIPT,
      getStockMovementType(StockMovementType.RECEIPT).text,
    )
    result = replaceStr(
      result,
      StockMovementType.ADJUSTOUT,
      getStockMovementType(StockMovementType.ADJUSTOUT).text,
    )
    result = replaceStr(result, StockMovementType.VOID, getStockMovementType(StockMovementType.VOID).text)
    result = replaceStr(
      result,
      StockMovementChannel.ANDROIND,
      getStockMovementChannel(StockMovementChannel.ANDROIND).text,
    )
    result = replaceStr(
      result,
      StockMovementChannel.IOS,
      getStockMovementChannel(StockMovementChannel.IOS).text,
    )
    result = replaceStr(
      result,
      StockMovementChannel.WEB,
      getStockMovementChannel(StockMovementChannel.WEB).text,
    )
    result = replaceStr(
      result,
      StockMovementChannel.POS,
      getStockMovementChannel(StockMovementChannel.POS).text,
    )
    result = replaceStr(
      result,
      StockMovementChannel.SUPPLIER,
      getStockMovementChannel(StockMovementChannel.SUPPLIER).text,
    )

    return result
  })

  return results.join('\r\n')
}

export const getRmxIngredientType = (category: string) => {
  let color = 'rgb(255, 191, 0)'
  switch (category) {
    case 'ปูนซีเมนต์':
      color = '#2f5496'
      break
    case 'ทราย':
      color = '#f3b083'
      break
    case 'หิน':
      color = '#7f7f7f'
      break

    default:
      break
  }
  return {
    color,
  }
}

export const percentCalulator = (val?: number, total?: number): number => {
  return ((val || 0) * 100) / (total || 0)
}

export const renderMonth = () => {
  const values = []
  for (let index = 1; index <= 12; index++) {
    const name = index <= 9 ? '0' + index : index
    values.push({
      name: monthNames.en[index - 1],
      value: name,
    })
  }

  return values
}

export const renderDateFormQuater = (quater: any) => {
  const endDate = moment(quater).add(2, 'M')
  return {
    startDate: toDateQuery(quater),
    endDate: toDateQuery(endDate),
  }
}

export const getMethod = (method: string) => {
  let text = ''
  let color = ''
  switch (method) {
    case 'GET':
      text = 'GET'
      color = 'green'
      break
    case 'POST':
      text = 'POST'
      color = 'blue'
      break
    case 'PUT':
      text = 'PUT'
      color = 'geekblue'
      break
    case 'DELETE':
      text = 'DELETE'
      color = 'red'
      break
    case 'OPTIONS':
      text = 'OPTIONS'
      color = 'yellow'
      break
    default:
      text = method
      break
  }
  return {
    text,
    color,
  }
}

export const hasThaiString = (str: string) => {
  const regex = new RegExp(`[\u0E00-\u0E7F']`)
  return regex.test(str)
}

export const isASCII = (str: string): boolean => {
  return /^[\x00-\x7F]*$/.test(str)
}

export const findResult = (id: number, data: any[]) => {
  const result = data.find(item => item?.id === id)
  return result
}

export const findName = (id: number, data: any[]) => {
  const result = data.find(item => item?.id === id)
  return result?.name || ''
}

export const findValue = (value: any, data: any[], key: string) => {
  const result = data.find(item => item[key] === value)
  return result
}

export const getAddressFormID = (data: AddressData[], id: number): AddressData | undefined => {
  return data && data.find(item => item.id === id)
}

export const getAddressFormZipcode = (data: AddressData[], zipcode: string): AddressData | undefined => {
  return data && data.find(item => item.zipcode === zipcode)
}

interface MenuProps {
  name: string
  value: string | number
}

export const mappingConfigSign = (menu: MenuProps[], value: any[]) => {
  const wording = [] as string[]
  value &&
    value.forEach(item => {
      const text = menu && menu.find(mn => mn.value === item)
      wording.push(text?.name || item)
    })
  return wording
}

export const getDefaultValueConfig = (menu: any[]): any[] => {
  const value = [] as any[]
  menu &&
    menu.forEach(item => {
      if (item?.isDefault) {
        value.push(item.value)
      }
    })
  return value
}

export const getConfigByKey = (configs: ConfigData[], key: string): ConfigData | undefined => {
  return configs && configs.find(item => item.config_name === key)
}

export const getEarnPointTitle = (data: any) => {
  let title = ''
  switch (data.point_type) {
    case EarnPointType.MANUAL:
      if (data.point < 0) {
        title = EarnPointTypeTitle.MANUAL_D
      } else {
        title = EarnPointTypeTitle.MANUAL_I
      }
      break
    case EarnPointType.ORDER:
      title = EarnPointTypeTitle.ORDER
      break
    case EarnPointType.ORDER_MANUAL:
      title = EarnPointTypeTitle.ORDER_MANUAL
      break
    default:
      title = data.point_type
      break
  }
  return title
}

export const cmToPx = (cm: number) => {
  return cm * 37.7952755906
}
